<!-- 供应链头部信息 -->
<template>
  <div class="partnerList">
    <el-dialog
      :title="$t('supplyChain.dialog.partnerList')"
      width="80%"
      :visible.sync="dialogVisible"
      append-to-body
      :before-close="handleClose"
    >
      <vxe-grid
        border
        show-overflow
        resizable
        ref="xTable"
        class="vxe-table-element"
        size="mini"
        align="left"
        :paging="true"
        :auto-resize="true"
        :data="partnerList"
        max-height="450px"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'partnerType'">
              {{ partnerTypeData[scope.row[item.prop]] }}
            </span>
            <span v-else-if="item.prop === 'requestStatus'">
              {{ requestStatusData[scope.row[item.prop]] }}
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{
          $t('supplyChain.button.cancel')
        }}</el-button>
        <el-button type="primary" @click="handleSure">{{
          $t('supplyChain.button.sure')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/supplyChain';
  import { mapState } from 'vuex';
  export default {
    name: 'partnerList',
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      columnList() {
        return [
          { prop: 'partnerType', label: this.$t('cooperation.label.partnerType') },
          { prop: 'partnerZhName', label: this.$t('cooperation.label.partnerZhName') },
          { prop: 'partnerCode', label: this.$t('cooperation.label.partnerCode') },
          { prop: 'identityNo', label: this.$t('cooperation.label.identityNo') },
          { prop: 'creditCode', label: this.$t('cooperation.label.creditCode') },
          { prop: 'requestByName', label: this.$t('cooperation.label.requestByName') },
          { prop: 'requestTime', label: this.$t('cooperation.label.requestTime') },
          // { prop: "requestStatus", label: this.$t('cooperation.label.requestStatus') },
        ];
      },
    },
    data() {
      return {
        dialogVisible: false,
        partnerList: [],
        partnerTypeData: {},
        requestStatusData: {},
      };
    },
    mounted() {
      this.getDictList();
    },
    methods: {
      openDialog(data) {
        this.partnerList = data;
        this.dialogVisible = true;
      },
      // 确定扩展
      handleSure() {
        this.selected = this.$refs.xTable.getCheckboxRecords();
        if (this.selected.length === 1) {
          const params = {
            partnerCode: this.selected[0].partnerCode,
            adminFlag: this.userInfo.adminFlag,
            checkFlag: '1',
            departmentCode: this.userInfo.departmentCode,
          };
          // 本部门查重
          this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
            if (res.data.code === 0) {
              if (res.data.data.length === 0) {
                delete params.departmentCode;
                // 全公司查重
                this.$axios.post(API.LIST_SUPPLIERS, params).then((res) => {
                  if (res.data.code === 0) {
                    if (res.data.data.length == 0) {
                      this.$emit('getPartner', this.selected[0]);
                      this.dialogVisible = false;
                    } else {
                      this.handleExtend(res.data.data);
                    }
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('supplyChain.message.dataRepeat'),
                  type: 'error',
                });
              }
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('supplyChain.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 扩展操作
      handleExtend(data) {
        this.dialogVisible = false;
        this.$emit('handleExtend', data);
      },
      getDictList() {
        const tenantCode = this.userInfo.tenantCode;
        // 合作伙伴类型
        this.$axios.post(API.DICT_LIST, { dictType: 'partner_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            for (var item of res.data.data) {
              // => 用于表格回显
              this.partnerTypeData[item['value']] = item['label'];
            }
          }
        });
        // 状态
        this.$axios.post(API.DICT_LIST, { dictType: 'request_status', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            for (var item of res.data.data) {
              // => 用于表格回显
              this.requestStatusData[item['value']] = item['label'];
            }
          }
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit('clearSupplierName');
      },
    },
  };
</script>

<style scoped></style>
